import request from './request.js';

/**
 *
 * @param {*} cursor
 * @param {*} query
 */
function getQuotesForReview(cursor, query = false) {
    const encodedQuery = query ? encodeURIComponent(query) : '';
    const endpoint = `/quotes/review?cursor=${ cursor }&query=${ encodedQuery }`;
    const options = {
        endpoint,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param advisorID
 * @param body
 * @returns {Promise<unknown>}
 */
function createQuote(advisorID, body) {
    const options = {
        endpoint: `/advisor/${ advisorID }/quote`,
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param advisorID
 * @param quoteID
 * @param body
 * @returns {Promise<unknown>}
 */
function editQuote(quoteID, body) {
    const options = {
        endpoint: `/quote/${ quoteID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function getQuote(quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param planType
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function savePlanType(planType, quoteID) {
    const options = {
        method: 'PUT',
        endpoint: `/quote/${ quoteID }/plan/type`,
        body: {
            planType
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function sendReviewRequest(quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }/reviewRequest`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param state
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function setState(state, quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }/state/${ state }`,
        method: 'PUT'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param coverages
 * @param quoteID
 */
function savePricingCoverages(classID, coverages, quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }/class/${ classID }/pricingCoverages`,
        method: 'POST',
        body: {
            coverages
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function convertQuote(quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }/convert`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param classID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function removeClass(classID, quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }/class/${ classID }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param divisionID
 * @param quoteID
 * @returns {Promise<unknown>}
 */
function removeDivision(divisionID, quoteID) {
    const options = {
        endpoint: `/quote/${ quoteID }/division/${ divisionID }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param quoteID
 * @param commissionSplitData
 * @returns {Promise<unknown>}
 */
function updateCommissionSplitsForQuote(quoteID, commissionSplitData) {
    const endpoint = `/quote/${ quoteID }/commissions/split`;

    const options = {
        method: 'PUT',
        endpoint,
        body: {
            commissionSplitData
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    createQuote,
    getQuote,
    savePlanType,
    getQuotesForReview,
    sendReviewRequest,
    savePricingCoverages,
    convertQuote,
    setState,
    removeClass,
    removeDivision,
    editQuote,
    updateCommissionSplitsForQuote
};